import { ReportData } from './types';
import { Timestamp } from 'firebase/firestore';

// Mock data for development/testing
export const mockReportData: ReportData = {
  questions: [
    {
      id: 1,
      text: "How effectively does the subject perform in their current role?",
      selfAssessment: 7,
      evaluators: [8, 9, 8, 9],
      visualization: "donut"
    },
    {
      id: 2,
      text: "How much do you value the subject's contributions to the team?",
      selfAssessment: 9,
      evaluators: [7, 6, 7, 8],
      visualization: "spider"
    },
    {
      id: 3,
      text: "How does the subject contribute to creating a positive workplace environment?",
      selfAssessment: 6,
      evaluators: [8, 9, 8, 9],
      visualization: "donut"
    }
  ],
  feedbackComments: {
    1: [
      "Consistently delivers high-quality work and meets deadlines",
      "Shows strong problem-solving abilities",
      "Could improve on documenting processes"
    ],
    2: [
      "Brings valuable insights to team discussions",
      "Actively participates in knowledge sharing", 
      "Technical expertise is highly valued"
    ],
    3: [
      "Creates an inclusive atmosphere",
      "Always willing to help others",
      "Could be more proactive in team events"
    ]
  },
  metadata: {
    generatedAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date()),
    status: 'completed',
    version: '1.0'
  }
};